import React from 'react';
import withData from '@bd/bdcore-data';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { get, orderBy } from 'lodash';
import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl, withSize } from '@bd/bdcore-utilities';
import moment from 'moment';

import { colors } from '../../styles';
import { UnderdogLeft } from '../../helpers/UIElements';

const styles = css`
  padding: 50px 20px;
  @media(min-width: 992px) {
    padding: 100px 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    background-color: ${colors.color2};
    margin: 2px 0;
    position: relative;
    &::before {
      content: '';
      width: 20vw;
      height: 100%;
      max-width: 360px;
      background-color: #2B2B2B;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  @media(min-width: 1450px) {
    padding: 100px 80px;
  }
  .BlogWidget_list  {
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    @media(min-width: 992px) {
      justify-content: flex-start;
      position: relative;
      z-index: 1;
    }
    li {
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      height: 218px;
      width: 100%;
      @media(min-width: 576px) {
        margin: 3px 3px 0 0;
        width: calc(50% - 4px);
      }
      @media(min-width: 992px) {
        max-width: 600px;
        height: 297px;
        flex: 1;
      }
      & + li {
        margin: 3px 0 0;
        @media(min-width: 576px) {
          margin: 3px 3px 0 0;
        }
      }
      .BlogWidget_item {
        width: 100%;
        height: 100%;
        padding: 40px 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        background-color: rgba(0, 0, 0, 0.37);
        transition: all .3s ease-out;
        &:hover {
          background-color: rgba(0, 0, 0, 0.57);
        }
      }
    }
  }
  .BlogWidget_itemTitle {
    font-weight: 700;
    font-size: 17px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 23px;
    @media(min-width: 1150px) {
      font-size: 18px;
      line-height: 24px;
    }
  }
  .BlogWidget_itemDate {
    font-weight: 900;
    text-transform: uppercase;
    font-size: 11px;
    color: #FFFFFF;
    letter-spacing: 2.54px;
    @media(min-width: 992px) {
      font-size: 13px;
      letter-spacing: 3px;
    }
  }
  .BlogWidget_btn {
    @media(min-width: 992px) {
      &::after, &::before {
        background-color: ${colors.color1};
      }
    }
    .BlogWidget_btnLink {
      font-weight: 300;
      font-size: 28px;
      color: #000000;
      letter-spacing: 0.88px;
      display: flex;
      flex-direction: column;
      @media(min-width: 992px) {
        flex-direction: row;
        font-size: 44px;
        color: #FFFFFF;
        letter-spacing: 1.38px;
      }
      span {
        font-weight: 900;
        text-transform: uppercase;
        font-size: 13px;
        color: ${colors.color1};
        letter-spacing: 1.95px;
        @media(min-width: 992px) {
          font-weight: 300;
          font-size: 44px;
          color: #FFFFFF;
          letter-spacing: 1.38px;
          text-transform: capitalize;
          margin: 0 8px 0 0;
        }
      }
    }
  }
`;

function BlogWidget({ blogposts, size }) {
  const ipadSize = size.width > 767 && size.width < 992;
  return (
    <div className={styles} style={{ zIndex: '100' }}>
      <div className="flex-lg-fill">
        <UnderdogLeft className={`BlogWidget_btn ${ipadSize ? 'container mx-auto' : ''}`}>
          <Link name="blog" className="BlogWidget_btnLink">Arjen Homes News</Link>
        </UnderdogLeft>
        <ul className="BlogWidget_list list-unstyled mb-5 mb-lg-0">
          {
            orderBy(blogposts, 'date', 'desc').slice(0, 4).map(item => (
              <li className="" key={item._id} style={{ backgroundImage: `url('${buildThumbnailUrl(get(item, 'logo.contentUrl'), { width: 800, height: 800 })}')` }} >
                <Link name="blogpost-detail" params={{ blogpostTitle: item.title }} className="BlogWidget_item">
                  <h5 className="BlogWidget_itemTitle">{get(item, 'title')}</h5>
                  <span className="BlogWidget_itemDate">{moment(get(item, 'date')).format('MMMM D, YYYY')}</span>
                </Link>
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  );
}

BlogWidget.propTypes = {
  blogposts: PropTypes.arrayOf(PropTypes.object).isRequired,
  size: PropTypes.object.isRequired,
};

export default withData({
  blogposts: true,
})(withSize()(BlogWidget));



// WEBPACK FOOTER //
// ./src/components/PageWrapper/PostsWidget.js